export const bs = {
  home: {
    download: {
      ios: 'Preuzmi na App Store-u',
      iosSubtitle: 'iPhone i iPad',
      cta: 'Preuzmi',
    },
    location: {
      useMyLocation: 'Koristi moju lokaciju',
      modalBadge: 'Lokacija',
      modalTitle: 'Izaberi grad',
      tabs: {
        cities: 'Gradovi',
        coords: 'Koordinate',
      },
      searchPlaceholder: 'Pretraži grad…',
      refresh: 'Osvježi',
      loading: 'Učitavam gradove…',
      empty: 'Nema gradova.',
      loadError: 'Ne mogu učitati gradove. Pokušaj ponovo.',
      scrollMore: 'Skrolaj da učitaš još…',
      coords: {
        latitude: 'Geografska širina (lat)',
        longitude: 'Geografska dužina (lng)',
        timezone: 'Vremenska zona (opciono)',
        latPlaceholder: 'npr. 43.8563',
        lngPlaceholder: 'npr. 18.4131',
        tzPlaceholder: 'npr. Europe/Sarajevo',
        tzHint: 'Ako je prazno, koristi se vremenska zona tvog uređaja.',
        apply: 'Koristi koordinate',
        clear: 'Očisti',
        invalidLat: 'Latitude mora biti između -90 i 90.',
        invalidLng: 'Longitude mora biti između -180 i 180.',
      },
    },
    header: {
      brand: 'Deenly',
      login: 'Prijava',
      downloadApp: 'Preuzmi aplikaciju',
      prayers: {
        fajr: 'Sabah',
        dhuhr: 'Podne',
        asr: 'Ikindija',
        maghrib: 'Akšam',
        isha: 'Jacija',
      },
    },
    hero: {
      badge: 'Veliki Update 2.0',
      titleLine1: 'Tvoj kompletan',
      titleGradient: 'Deen, iznova.',
      subtitle:
        'Od vrhunskog scholarly feed-a i AI Tajweed-a do AR Kabe, live prevoda hutbe i Kids Mode-a sa PIN zaštitom. Sve što ti treba.',
    },
    nextPrayer: {
      label: 'Sljedeći namaz',
      statusOnTime: 'Na vrijeme',
      startsIn: 'Za',
      meta: {
        locationLabel: 'Sarajevo',
        methodLabel: 'MWL metoda',
        alertsOn: 'Obavijesti uključene',
        alertsOff: 'Obavijesti isključene',
      },
    },
    podcast: {
      badge: 'SCHOLAR PODCAST',
      titlePrefix: 'Tumačenje knjige:',
      titleMain: 'Rijadus-salihin',
      author: 'Šejh Mufti Menk',
    },
    features: {
      title: 'Sve što ti treba.',
      subtitle: 'Prelijepo izrađeni alati za čitanje, slušanje, praćenje i svakodnevni ibadet.',
      core: {
        dynamicFeed: {
          title: 'Dinamični feed',
          body: 'Knjige, stranice, hadisi, dnevni ajeti i podcasti koji pojašnjavaju klasična djela.',
          bookAddedLabel: 'Dodana knjiga',
          bookAddedValue: 'Zapečaćeni nektar',
          podcastLabel: 'Podcast',
          podcastValue: 'Tefsir Ibn Kesir',
        },
        mosqueNavigator: {
          badge: 'Live nav',
          title: 'Pametna navigacija do džamije',
          body:
            "Navigacija svjetske klase koja te vodi do najbliže džamije. Odaberi omiljeni mesdžid, prati ETA i ne propuštaj džemat.",
          cardTitle: 'Centralna džamija',
          cardMeta: 'ETA: 5 min • Pješke',
        },
        dreamInterpreter: {
          title: 'AI tumačenje snova',
          body: 'Razumij svoje snove kroz islamsku prizmu uz AI treniran na klasičnim tekstovima.',
          cta: 'Pitaj sada',
        },
        libraryStats: {
          title: 'Pametna biblioteka i statistika',
          body:
            'Čitaj Kur’an bez prekida. Dugim pritiskom spremi ajet ili otvori Tajweed modal i pročitaj naglas za instant AI feedback. Pomoću slidera izračunaj kada završavaš Kur’an.',
          chips: {
            pages: 'Stranice',
            bookmarks: 'Oznake',
            tajweedCheck: 'Tajweed provjera',
          },
          paceLabel: 'Dnevni tempo',
          paceValue: '20 ajeta',
          finishLabel: 'Završi Kur’an za',
          finishValue: '105 dana',
          longPressLabel: 'Dugi pritisak',
          longPressValue: 'Ajet 255',
        },
      },
      premium: {
        badge: 'Ultimate kolekcija',
        title: 'Premium islamski alati',
        subtitle: 'Kompletan set moćnih alata za svakog muslimana.',
        arQibla: {
          title: 'AR kibla i Kaba',
          body:
            'Pronađi tačan smjer kible uz napredni AR. Postavi virtualnu Kabu ispred sebe za potpuno uranjanje.',
          cta: 'Otvori AR',
        },
        postureGuide: {
          title: 'Vodič položaja',
          body:
            'Postavi telefon ispred sebe. Naš AI prepoznaje pokrete i vodi te kroz pravilne namaske položaje.',
        },
        liveKhutbah: {
          title: 'Live hutba',
          body:
            'Na džumi u inostranstvu? Dobij real-time AI prevod hutbe direktno na ekran.',
        },
        tajweed: {
          title: 'AI učenje učenja Kur’ana',
          body:
            'Vježbaj učenje. AI sluša tvoj tajweed i odmah označava mjesta za poboljšanje uz precizan feedback.',
        },
        essentials: {
          title: 'Osnovni dnevni alati',
          body:
            'Sve ostalo što ti treba: halal skener sastojaka, tap tesbih i precizan kalkulator zekata.',
          halalScanner: 'Halal skener',
          tapTasbih: 'Tap tesbih',
          zakat: 'Kalkulator zekata',
        },
      },
    },
    kids: {
      badge: 'Deenly Kids',
      title: 'Siguran i lijep prostor za tvoje mališane.',
      subtitle:
        'Sve što je potrebno djetetu da uči i mirno zaspi, zaključano iza roditeljskog PIN-a.',
      items: {
        pictureBooks: {
          title: 'Slikovnice',
          body: 'Interaktivne, prelijepo ilustrovane priče koje uče islamskim vrijednostima i moralu.',
        },
        lullabies: {
          title: 'Halal uspavanke (bez muzike)',
          body: 'Umirujući vokali snimljeni za bebe. Strogo bez muzike.',
        },
        whiteNoise: {
          title: 'Bijeli šum i zvukovi spavanja',
          body: 'Izbor umirujućih prirodnih ambijenata i bijelog šuma za lakši san.',
        },
        games: {
          title: 'Edukativne igre',
          body: 'Zabavne, sigurne i potpuno edukativne mini-igre za mlađu djecu.',
        },
        pin: {
          title: 'PIN sigurni režim',
          badge: 'Zaključano',
          body: 'Djeca su zaključana u Kids okruženju i ne mogu izaći bez roditeljskog PIN-a.',
        },
      },
    },
    cta: {
      title: 'Započni svoje putovanje danas.',
      subtitle: 'Pridruži se milionima muslimana koji grade bolje dnevne navike uz Deenly.',
      ios: 'Preuzmi za iOS',
      android: 'Preuzmi za Android',
    },
    footer: {
      copyright: '© 2023 Deenly. Sva prava zadržana.',
      links: {
        privacy: 'Politika privatnosti',
        terms: 'Uslovi korištenja',
        contact: 'Kontakt',
      },
    },
  },
  legal: {
    privacy: {
      metaTitle: 'Privatnost i uslovi • Deenly',
      header: {
        badge: 'Pravni dokument',
        back: 'Nazad',
      },
      hero: {
        titlePrefix: 'Politika ',
        titleGradient: 'privatnosti.',
        subtitle:
          'Vjerujemo da su vaši podaci vaša stvar, ne naša. Naša filozofija je da prikupljamo što je manje moguće, a da isporučimo vrhunsko iskustvo.',
        lastUpdatedLabel: 'Zadnje ažuriranje',
        badgeIcon: 'solar:shield-check-linear',
        calendarIcon: 'solar:calendar-linear',
      },
      languageLabel: 'Jezik',
      lang: {
        en: 'English',
        bs: 'Bosanski',
      },
      search: {
        title: 'Pretraga',
        placeholder: 'Pretraži (npr. “podaci”, “nalog”, “treće strane”)',
        found: 'Pronađeno sekcija',
        clear: 'Očisti',
        tocTitle: 'Sadržaj',
        tocHint: 'Skok na sekciju.',
        emptyTitle: 'Nema rezultata',
        emptyBody:
          'Nijedna sekcija ne odgovara pretrazi. Probajte drugi pojam.',
        backToTop: 'Nazad na vrh',
        backHome: 'Nazad na početnu',
      },
      tldr: {
        title: 'Ukratko',
        icon: 'solar:bolt-linear',
        cards: [
          {
            icon: 'solar:eye-closed-linear',
            title: 'Bez reklama',
            body: 'Ne prodajemo vaše podatke oglašivačima. Održava se premium pretplatama.',
          },
          {
            icon: 'solar:map-point-linear',
            title: 'Lokalna lokacija',
            body: 'Vremena namaza se računaju na vašem uređaju. Ne pratimo vaše kretanje.',
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Šifrovana sinhronizacija',
            body: 'Vaše oznake i lična statistika su šifrovani u prijenosu i u mirovanju.',
          },
          {
            icon: 'solar:smile-circle-linear',
            title: 'Djeca su sigurna',
            body: 'Kids Mode je usklađen sa COPPA i ne prikuplja telemetriju.',
          },
        ],
      },
      toc: [
        { id: 'tldr', label: 'Ukratko' },
        { id: 'collection', label: 'Prikupljanje' },
        { id: 'usage', label: 'Upotreba podataka' },
        { id: 'kids', label: 'Privatnost djece' },
        { id: 'sharing', label: 'Dijeljenje' },
        { id: 'security', label: 'Sigurnost' },
        { id: 'contact', label: 'Kontakt' },
      ],
      collection: {
        title: 'Informacije koje prikupljamo',
        intro:
          'Posvećeni smo minimalnom prikupljanju podataka. Evo tačno šta se dešava kada koristite Deenly.',
        items: [
          {
            icon: 'solar:key-minimalistic-2-linear',
            title: 'Identitet uređaja (UUID)',
            bodyParts: [
              { text: 'Pri prvom pokretanju, aplikacija generiše nasumični ', highlight: false },
              { text: 'UUID', highlight: true },
              { text: ' i sigurno ga čuva u sesiji uređaja (Keychain / Keystore). Ovaj identifikator se koristi isključivo za registraciju uređaja na našim serverima i ne napušta uređaj osim za autentikaciju s našim API-jem.', highlight: false },
            ],
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Token sesije (JWT)',
            bodyParts: [
              { text: 'Nakon registracije, naš server izdaje ', highlight: false },
              { text: 'JWT', highlight: true },
              { text: ' koji se čuva isključivo u sesiji uređaja. Svi naredni API zahtjevi koriste ovaj token. Nema klasičnog logina s korisničkim imenom i lozinkom — vaš identitet je vaša sesija uređaja.', highlight: false },
            ],
          },
          {
            icon: 'solar:routing-2-linear',
            title: 'Podaci o lokaciji (na uređaju)',
            bodyParts: [
              { text: 'Potrebno isključivo za tačan izračun vremena namaza i kible. Računanje se vrši ', highlight: false },
              { text: 'lokalno na vašem uređaju', highlight: true },
              { text: '. Nikada ne čuvamo niti šaljemo historiju vaše lokacije.', highlight: false },
            ],
          },
          {
            icon: 'solar:mic-2-linear',
            title: 'Pristup mikrofonu',
            body:
              'Koristi se za AI provjeru učenja Kur\'ana i Hutba uživo prijevod. Prepoznavanje govora radi na vašem uređaju — sam audio se nikada ne šalje, ne snima niti čuvamo. Ono što može napustiti uređaj jeste tekst, opisano ispod.',
          },
          {
            icon: 'solar:document-text-linear',
            title: 'AI obrada teksta (transkripti i snovi)',
            bodyParts: [
              { text: 'Neke AI funkcije traže više računarske snage nego što telefon ima. Kada koristite Hutba uživo prijevod, prepoznati ', highlight: false },
              { text: 'tekst svake rečenice', highlight: true },
              { text: ' (nikada audio) šalje se enkriptovanom vezom na naše servere i prosljeđuje pouzdanom AI partneru za obradu, koji vraća prijevod i sažetak hutbe. Opisi snova koje pošaljete Interpreteru obrađuju se na isti način. Ovi zahtjevi nose samo sesiju vašeg uređaja — ne vaše ime niti kontakt podatke. Historija hutbi čuva se samo na vašem uređaju; prijevodi se keširaju na našim serverima do 30 dana kako bi cijeli džemat koji prati istu hutbu bio poslužen trenutno; transkripti dijeljenih "soba" brišu se sa naših servera u roku od nekoliko sati.', highlight: false },
            ],
          },
        ],
      },
      usage: {
        title: 'Kako koristimo podatke',
        intro:
          'Sve podatke koristimo isključivo da poboljšamo vaše iskustvo. Ne radimo bihevioralno profilisanje.',
        cards: [
          {
            icon: 'solar:cloud-sync-linear',
            title: 'Cloud sinhronizacija',
            body:
              'Sinhronizujte oznake u Kur’anu, dnevnu statistiku i podešavanja između uređaja.',
          },
          {
            icon: 'solar:magic-stick-3-linear',
            title: 'Obrada AI funkcija',
            body:
              'Prijevod hutbe rečenicu po rečenicu, sažeci hutbi i tumačenja snova nastaju iz teksta poslanog našim serverima i pouzdanom AI partneru za obradu. Zahtjevi su vezani samo za sesiju uređaja i nikada se ne koriste za profilisanje.',
          },
        ],
      },
      kids: {
        title: 'Privatnost Kids Mode-a',
        intro:
          'Privatnost maloljetnika shvatamo izuzetno ozbiljno. Kids dio je sigurno, offline-first okruženje.',
        badge: {
          icon: 'solar:star-fall-minimalistic-2-linear',
          label: 'Posebna odredba',
        },
        items: [
          { icon: 'solar:shield-check-linear', text: 'Nema praćenja niti analitike u Kids Mode-u.' },
          { icon: 'solar:document-text-linear', text: 'Usklađeno sa COPPA i GDPR-K.' },
          { icon: 'solar:lock-password-linear', text: 'Nema eksternih linkova ili kupovina bez roditeljskog PIN-a.' },
        ],
      },
      sharing: {
        title: 'Dijeljenje podataka',
        body:
          'Ne prodajemo, ne iznajmljujemo i ne trgujemo ličnim informacijama. Dijelimo samo sa pouzdanim infrastrukturnim partnerima isključivo radi rada aplikacije — uključujući AI partnera za obradu koji dobija samo tekst potreban za konkretnu funkciju (rečenicu hutbe za prijevod, opis sna za tumačenje), nikada vaš identitet. Partneri su vezani strogim ugovorima o povjerljivosti i ne smiju koristiti vaše podatke u vlastite svrhe, uključujući oglašavanje ili treniranje na vašem sadržaju.',
      },
      security: {
        title: 'Sigurnosne mjere',
        body:
          'Vaše povjerenje je naše najveće bogatstvo. Primjenjujemo savremene mjere zaštite. Komunikacija je zaštićena TLS enkripcijom. Vaš UUID i JWT čuvaju se isključivo u sigurnoj sesiji vašeg uređaja (Keychain na iOS-u, Keystore na Androidu) i nisu dostupni izvan uređaja.',
      },
      contactCta: {
        title: 'Briga oko privatnosti?',
        subtitle: 'Naš privacy tim je spreman da pomogne.',
        button: 'Kontaktiraj privacy tim',
        icon: 'solar:letter-linear',
      },
      footerNote: 'Sva prava zadržana. Dizajnirano s iskrenim namjerama.',
      footer: {
        links: {
          terms: 'Uslovi',
          privacy: 'Privatnost',
          cookies: 'Kolačići',
        },
      },
    },
  },
};

